import React from 'react';
import { useSelector } from 'react-redux';

import { Container } from './style';
import { ChatIndice } from '../components/chat';
import { ChatGroup } from '../components/chatGroups';

export const Chat = ({
  unreadFromUsers,
  setUnreadFromUsers,
  unreadGroups,
  setUnreadGroups
}) => {
  const data = useSelector((state) => state.activeChatInternal.chats);

  return (
    <Container>
      {data.map((item, index) => {
        if (item.type === 'group') {
          return (
            <ChatGroup
              key={item.login}
              group={item}
              unreadGroups={unreadGroups}
              setUnreadGroups={setUnreadGroups}
            />
          );
        }

        return (
          <ChatIndice
            key={index}
            data={item}
            unreadFromUsers={unreadFromUsers}
            setUnreadFromUsers={setUnreadFromUsers}
          />
        );
      })}
    </Container>
  );
};
